import React from 'react';
import PageHeader from '../Component/PageHeader';
import CompanyName from '../Component/CompanyName';
import { Link } from '@mui/material';
import { Helmet } from 'react-helmet';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import RestorationData from '../Restoration/Restoration.json';
import YachtCarousel from '../YachtsForSale/YachtCarousel';
import JustEnough1 from '../Images/JustEnough/JustEnough.jpg';
import JustEnough2 from '../Images/JustEnough/JustEnough-1.jpg';
import JustEnough3 from '../Images/JustEnough/JustEnough-2.jpg';
import JustEnough4 from '../Images/JustEnough/JustEnough-3.jpg';
import JustEnough6 from '../Images/JustEnough/JustEnough-5.jpg';
import JustEnough7 from '../Images/JustEnough/JustEnough-6.jpg';
import JustEnough8 from '../Images/JustEnough/JustEnough-7.jpg';
import JustEnough9 from '../Images/JustEnough/JustEnough-8.jpg';

const JustEnough = () => {

    const RestorationJustEnough = RestorationData.find(boat => boat.ID === "2");

    return (
        <div className='text-[#104895]'>
            <PageHeader pageTitle="2012 Just Enough 141' Ares Marine Motor Yacht" />

            <Helmet>
                <title data-react-helmet="true">Complete Restoration of 2012 Just Enough 141' Ares Marine Motor Yacht in Florida</title>
                <meta data-react-helmet="true" name="description" content="Discover the complete restoration of the 2012 Ares Marine Motor Yacht 'Just Enough', Experience its renewed elegance and state-of-the-art amenities. Learn more about this exquisite yacht restoration project today!" />
                <meta data-react-helmet="true" property="og:title" content="Complete Restoration of 2012 Just Enough 141' Ares Marine Motor Yacht in Florida" />
                <meta data-react-helmet="true" property="og:type" content="website" />
                <meta data-react-helmet="true" property="og:url" content="https://aresmarine.com/YachtsForSale/JustEnough/" />
                <meta data-react-helmet="true" property="og:image" content="https://webdesignexpressions.net/assets/OGJustEnough.jpg" />
                <meta data-react-helmet="true" property="og:description" content="Discover the complete restoration of the 2012 Ares Marine Motor Yacht 'Just Enough', a 141' masterpiece located in Florida. Experience its renewed elegance and state-of-the-art amenities. Learn more about this exquisite yacht restoration project today!" />
            </Helmet>

            {RestorationJustEnough && (
                <div>

                    <div className='mb-5'>
                        <div className='pb-2'><img src={RestorationJustEnough.Image} className='rounded-sm drop-shadow-md border-2 border-[#f0f0f0]' alt={`${RestorationJustEnough.Type} ${RestorationJustEnough.Year} ${RestorationJustEnough.BoatName} ${RestorationJustEnough.Length} ${RestorationJustEnough.Make} `} title={`${RestorationJustEnough.Type} ${RestorationJustEnough.Year} ${RestorationJustEnough.BoatName} ${RestorationJustEnough.Length} ${RestorationJustEnough.Make} `} /></div>

                        <div className='lg:flex lg:gap-5'>
                            <div className='lg:w-1/2'>
                                <TableContainer>
                                    <Table sx={{ backgroundColor: 'transparent' }} aria-label="empty table">


                                        <TableBody>
                                            {/* Add TableRow with a line after each row */}
                                            <TableRow className="table-row">
                                                <TableCell style={{ width: '50%' }}><div className='text-[#104895]'><b>Builder:</b></div></TableCell>
                                                <TableCell style={{ width: '50%' }}><div className='text-[#104895]'><b>{RestorationJustEnough.Make}</b></div></TableCell>
                                            </TableRow>


                                            <TableRow className="table-row">
                                                <TableCell style={{ width: '50%' }}><div className='text-[#104895]'><b>Length:</b></div> </TableCell>
                                                <TableCell style={{ width: '50%' }}><div className='text-[#104895]'><b>{RestorationJustEnough.Length}</b></div></TableCell>
                                            </TableRow>




                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>


                            <div className='lg:w-1/2'>
                                <TableContainer>
                                    <Table sx={{ backgroundColor: 'transparent' }} aria-label="empty table">


                                        <TableBody>

                                            <TableRow className="table-row">
                                                <TableCell style={{ width: '50%' }}><div className='text-[#104895]'><b>Yeare:</b></div> </TableCell>
                                                <TableCell style={{ width: '50%' }}><div className='text-[#104895]'><b>{RestorationJustEnough.Year}</b></div></TableCell>
                                            </TableRow>

                                            <TableRow className="table-row" >
                                                <TableCell style={{ width: '50%' }}><div className='text-[#104895]'><b>Refit Year:</b></div> </TableCell>
                                                <TableCell style={{ width: '50%' }}><div className='text-[#104895]'><b>{RestorationJustEnough.Refit}</b></div></TableCell>
                                            </TableRow>



                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>



                    </div>

                </div>

            )}




            <div className='pb-5'>
                <CompanyName /> proudly presents the meticulously restored 42.98m/141' motor yacht 'Just Enough', <Link href='/YachtsForSale/JustEnough' title="2012 Just Enough 141' Ares Marine Motor Yacht for Sale">now available for sale</Link>. Painstakingly refurbished by <CompanyName />, this vessel exudes timeless elegance and offers unparalleled luxury and comfort for up to 11 guests across 5 cabins. Retaining the hallmark interior styling of <CompanyName />, 'Just Enough' boasts a refined ambiance that sets the stage for unforgettable journeys on the open seas.
            </div>
            <div className='pb-5'>
                From intimate gatherings to lively celebrations, 'Just Enough' provides an array of convivial spaces perfect for indulging in the ultimate luxury yacht experience. Whether you seek relaxation or adventure, this restored yacht invites you to unwind in style or dive into the crystal-clear waters with its comprehensive selection of water toys.
            </div>
            <div className='pb-5'>
                Families will find 'Just Enough' particularly appealing, thanks to its child-friendly amenities and thoughtful layout. Boasting a master suite on the main deck, along with two double cabins and two cabins that effortlessly convert between twins or doubles, this restored yacht ensures comfort and convenience for all guests. With accommodation for up to 11 guests and a dedicated crew of 9, every aspect of your journey is meticulously attended to.
            </div>
            <div className='pb-5'>
                Embrace onboard comfort and entertainment with 'Just Enough's' luxurious amenities, including a deck jacuzzi for soaking in panoramic views while sipping your favorite beverage. Stay connected with Wi-Fi connectivity and enjoy complete climate control with the vessel's air conditioning system.
            </div>
            <div className='pb-5'>
                Powered by twin Caterpillar engines, 'Just Enough' combines exceptional performance with impressive range. With a cruising speed of 12 knots and a maximum speed of 18 knots, she can traverse vast distances with ease, supported by a range of up to 3,500 nautical miles. Equipped with advanced stabilization technology, this restored yacht promises unparalleled comfort whether at anchor or underway.
            </div>
            <div>
                Prepare for endless fun on the water with 'Just Enough's' extensive collection of toys and accessories. From tri-deck waterslides to WaveRunners, waterskis, kayaks, and more, there's something for every member of the family to enjoy. Plus, with two tenders, including a 9.75m/32' Maverick Sportfisher, you can explore remote coves and hidden gems with ease.
            </div>



            <div className='mt-10'>
                <YachtCarousel boatName="2012 Just Enough 141' Ares Marine Motor Yacht"
                    images={[

                        { src: JustEnough1, title: '| Starboard Profile' },
                        { src: JustEnough2, title: '| Hot Tub' },
                        { src: JustEnough3, title: '| Flybridge Deck' },
                        { src: JustEnough4, title: '| Aft Flybridge Deck' },

                        { src: JustEnough6, title: '| Sky Lounge' },
                        { src: JustEnough7, title: '| Aft View Sky Lounge' },
                        { src: JustEnough8, title: '| Sky Lounge Bar' },
                        { src: JustEnough9, title: '| Main Salon' },

                    ]} />



            </div>
        </div >
    )
}

export default JustEnough